import dayjs from "dayjs";

// This module always displays dates as dd-mm-yyyy on the client,
// regardless of the ISO (yyyy-mm-dd) shape the data/API uses internally.
export function formatDisplayDate(date: string | dayjs.Dayjs): string {
  return dayjs(date).format("DD-MM-YYYY");
}

export function formatInteger(value: number): string {
  return Math.round(value).toLocaleString("en-US");
}

export function formatCurrency(value: number): string {
  const sign = value < 0 ? "-$" : "$";
  return (
    sign +
    Math.abs(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

export function formatPercent(value: number, decimals: number = 1): string {
  return `${value.toFixed(decimals)}%`;
}
